const ContentSubHeading = () => {
  return (
    <div className="text-[14px] leading-[18px] sm:text-[20px] sm:leading-[28px] tracking-[0.02em] text-[#F8FAFC] font-[Gilroy-Regular] text-center">
      DSA | System Design | Full-Stack Development | Java SpringBoot | Agentic AI
    </div>
  );
};

export default ContentSubHeading;
